import { Case } from "@graphql/generated";

const getDistinctYears = (allProperties?: Case[]) => {
  return allProperties?.reduce((acc: number[], curr) => {
    if (curr.taxYear && !acc.includes(curr.taxYear)) {
      return [...acc, curr.taxYear]
    }

    return acc
  }, [])?.sort()?.reverse() || []
}

export default getDistinctYears
